"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicModulesApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class DynamicModulesApi extends runtime.BaseAPI {
    /**
     * Returns all modules registered dynamically by the calling app.  **[Permissions](#permissions) required:** Only Connect apps can make this request.
     * Get modules
     */
    dynamicModulesResourceGetModulesGetRaw(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/app/module/dynamic`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ConnectModulesFromJSON)(jsonValue));
        });
    }
    /**
     * Returns all modules registered dynamically by the calling app.  **[Permissions](#permissions) required:** Only Connect apps can make this request.
     * Get modules
     */
    dynamicModulesResourceGetModulesGet(initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.dynamicModulesResourceGetModulesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Registers a list of modules.  **[Permissions](#permissions) required:** Only Connect apps can make this request.
     * Register modules
     */
    dynamicModulesResourceRegisterModulesPostRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['connectModules'] == null) {
                throw new runtime.RequiredError('connectModules', 'Required parameter "connectModules" was null or undefined when calling dynamicModulesResourceRegisterModulesPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/app/module/dynamic`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ConnectModulesToJSON)(requestParameters['connectModules']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Registers a list of modules.  **[Permissions](#permissions) required:** Only Connect apps can make this request.
     * Register modules
     */
    dynamicModulesResourceRegisterModulesPost(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.dynamicModulesResourceRegisterModulesPostRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Remove all or a list of modules registered by the calling app.  **[Permissions](#permissions) required:** Only Connect apps can make this request.
     * Remove modules
     */
    dynamicModulesResourceRemoveModulesDeleteRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['moduleKey'] != null) {
                queryParameters['moduleKey'] = requestParameters['moduleKey'];
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/app/module/dynamic`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove all or a list of modules registered by the calling app.  **[Permissions](#permissions) required:** Only Connect apps can make this request.
     * Remove modules
     */
    dynamicModulesResourceRemoveModulesDelete(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.dynamicModulesResourceRemoveModulesDeleteRaw(requestParameters, initOverrides);
        });
    }
}
exports.DynamicModulesApi = DynamicModulesApi;
//# sourceMappingURL=DynamicModulesApi.js.map